module.exports = __webpack_public_path__ + "static/media/S32_B.eea80807.png";